import { StateCreator } from 'zustand';
import type { EmployeeType } from '../../services/api/models/EmployeeType';

export interface PayrollFilters {
  clinicId: string | null;
  /** ISO date strings (yyyy-mm-dd); both required before fetching. */
  startDate: string | null;
  endDate: string | null;
  /** Ordered selection; an empty array means all employee types. */
  employeeTypes: EmployeeType[];
  search: string;
  /** Exclude imported patients from payroll results by default. */
  hideImportedPatients?: boolean;
}

export interface PayrollSlice {
  payrollFilters: PayrollFilters;
  initialDefaultsApplied: boolean;
  setPayrollFilters: (filters: Partial<PayrollFilters>) => void;
  setInitialDefaultsApplied: (applied: boolean) => void;
}

const DEFAULT_PAYROLL_FILTERS: PayrollFilters = {
  clinicId: null,
  startDate: null,
  endDate: null,
  employeeTypes: [],
  search: '',
  hideImportedPatients: true,
};

export const payrollSlice: StateCreator<PayrollSlice> = set => ({
  payrollFilters: DEFAULT_PAYROLL_FILTERS,
  initialDefaultsApplied: false,
  setPayrollFilters: (filters: Partial<PayrollFilters>) =>
    set(state => ({
      payrollFilters: { ...state.payrollFilters, ...filters },
    })),
  setInitialDefaultsApplied: (applied: boolean) =>
    set({ initialDefaultsApplied: applied }),
});
